export type Layout =
    | 'empty'
    // Horizontal
    | 'centered'
    | 'enterprise'
    | 'material'
    | 'modern'
    // Vertical
    | 'classic'
    | 'classy'
    | 'compact'
    | 'dense'
    | 'futuristic'
    | 'thin';
